import { useEffect, useRef } from 'react';

const FOCUS_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export function useFocusTrap(isOpen) {
  const containerRef = useRef(null);
  const previouslyFocused = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    previouslyFocused.current = document.activeElement;

    const focusable = containerRef.current?.querySelectorAll(FOCUS_SELECTOR) || [];
    const first = focusable[0];
    if (first) {
      first.focus();
    }

    return () => {
      if (previouslyFocused.current && previouslyFocused.current.focus) {
        previouslyFocused.current.focus();
      }
    };
  }, [isOpen]);

  const onKeyDown = (event) => {
    if (!isOpen || event.key !== 'Tab') return;
    const focusable = containerRef.current?.querySelectorAll(FOCUS_SELECTOR) || [];
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  return { containerRef, onKeyDown };
}
